(function () {
  'use strict';
  var label = 'Zur Kasse';
  function update() {
    document.querySelectorAll('.cart__checkout-button .button-text').forEach(function (element) {
      if (element.textContent.trim() !== label) element.textContent = label;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  var observer = new MutationObserver(update);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
